<template>
    <div class="content_box mobile_content">
        <div class="content">
            <div class="title_box">
                <div class="title">
                    <span>产品常见问题&活动管理</span>
                </div>
            </div>
            <el-form label-width="100px" :model="searchData" ref="formRule">
                <el-form-item label="产品">
                    <el-select v-model="searchData.product" placeholder="请选择产品">
                        <el-option :label="item" :value="item" v-for="item in appData.product" :key="item"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="语言">
                    <el-select v-model="searchData.lang" placeholder="请选择语言">
                        <el-option :label="item" :value="key" v-for="(item, key) in appData.lang" :key="key"></el-option>
                    </el-select>
                </el-form-item>
                <div class="faq_box">
                    <div class="faq_title">活动外链 <i class="el-icon-circle-plus-outline add_faq" @click="addEventsItem(false)"></i></div>
                    <div class="add_faq_box">
                        <div class="add_item" v-for="(item, i) in addEventsData" :key="i + 987654">
                            <el-form-item label="名称">
                                <el-input v-model="item.name" placeholder="请输入活动名称"></el-input>
                            </el-form-item>
                            <el-form-item label="链接" class="textarea_item">
                                <el-input v-model="item.link" placeholder="请输入活动链接"></el-input>
                            </el-form-item>
                            <div class="act_box">
                                <i class="el-icon-circle-plus-outline add_faq" @click="addEventsItem(i+1)"></i>
                                <i class="el-icon-delete del_faq" @click="delEventsItem(i)"></i>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="faq_box">
                    <div class="faq_title">常见问题 <i class="el-icon-circle-plus-outline add_faq" @click="addFaqItem(false)"></i></div>
                    <div class="add_faq_box">
                        <div class="add_item">
                            <el-form-item label="类型" class="textarea_item">
                                <!-- <el-input v-model="searchData.type" placeholder="请输入类型"></el-input> -->
                                <el-select v-model="searchData.type" allow-create filterable placeholder="请选择类型">
                                    <template v-if="faqConfig[searchData.product] && faqConfig[searchData.product][searchData.lang] && faqConfig[searchData.product][searchData.lang].faq">
                                        <el-option :label="key" :value="key" v-for="(item, key) in faqConfig[searchData.product][searchData.lang].faq" :key="key"></el-option>
                                    </template>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="add_item" v-for="(item, i) in addFaqData" :key="i + 987654">
                            <el-form-item label="问题">
                                <el-input v-model="item.q" placeholder="请输入问题"></el-input>
                            </el-form-item>
                            <el-form-item label="回答" class="textarea_item">
                                <el-input type="textarea" autosize :rows="1" v-model="item.a" placeholder="请输入回答"></el-input>
                            </el-form-item>
                            <div class="act_box">
                                <i class="el-icon-circle-plus-outline add_faq" @click="addFaqItem(i+1)"></i>
                                <i class="el-icon-delete del_faq" @click="delFaqItem(i)"></i>
                            </div>
                        </div>
                    </div>
                </div>
                <el-form-item>
                    <div class="btn">
                        <div class="button" @click="updateConfirm">
                            <span>提交</span>
                        </div>
                    </div>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>
<script>
import aliOss from '../../../aliOss/index'
export default({
    name: 'psc-faq-update',
    data() {
        return {
            searchData: {
                product: '',
                lang: 'zh',
                type: ''
            },
            faqConfig: '',
            addFaqData: [],
            addEventsData: [],
        }
    },
    watch: {
        searchData: {
            deep: true,
            handler(nD, oD) {
                if(nD.product && nD.lang && nD.type) {
                    this.addFaqData = (this.faqConfig && this.faqConfig[nD.product] && this.faqConfig[nD.product][nD.lang] && this.faqConfig[nD.product][nD.lang]['faq'] && this.faqConfig[nD.product][nD.lang]['faq'][nD.type]) ? this.faqConfig[nD.product][nD.lang]['faq'][nD.type] : [];
                }
                if(nD.product && nD.lang) {
                    this.addEventsData = (this.faqConfig && this.faqConfig[nD.product] && this.faqConfig[nD.product][nD.lang] && this.faqConfig[nD.product][nD.lang]['events']) ? this.faqConfig[nD.product][nD.lang]['events'] : [];
                }
            }
        }
    },
    created() {
        this.getConfig();
    },
    methods: {
        getConfig() {
            aliOss.getFile('config.json').then(r => {
                this.faqConfig = JSON.parse(r.content);
                this.searchData.product = 'M1';
                this.searchData.type = (this.faqConfig[this.searchData.product] && this.faqConfig[this.searchData.product][this.searchData.lang] && this.faqConfig[this.searchData.product][this.searchData.lang].faq) ? Object.keys(this.faqConfig[this.searchData.product][this.searchData.lang].faq)[0] : 'M1';
            })
        },
        updateConfirm() {
            if(!this.faqConfig[this.searchData.product]) {
                this.faqConfig[this.searchData.product] = {
                    [this.searchData.lang]: {
                        faq: {},
                        events: {}
                    }
                };
            }else if(!this.faqConfig[this.searchData.product][this.searchData.lang]) {
                this.faqConfig[this.searchData.product][this.searchData.lang] = {};
                this.faqConfig[this.searchData.product][this.searchData.lang].faq = {};
                this.faqConfig[this.searchData.product][this.searchData.lang].events = {};
            }
            if(this.addFaqData.length == 0) {
                delete this.faqConfig[this.searchData.product][this.searchData.lang]['faq'][this.searchData.type]
            }else{
                this.faqConfig[this.searchData.product][this.searchData.lang]['faq'][this.searchData.type] = this.addFaqData;
            }
            this.faqConfig[this.searchData.product][this.searchData.lang].events = this.addEventsData;
            console.log(this.faqConfig);
            aliOss.putFile('config.json', this.faqConfig, 'application/json').then(r => {
                this.$message.success('提交成功!');
            })
        },
        addFaqItem(i) {
            const obj = {
                q: '',
                a: ''
            };
            console.log(i)
            if(i) {
                this.addFaqData.splice(i, 0, obj)
            }else{
                this.addFaqData.unshift(obj);
            }   
            
        },
        delFaqItem(i) {
            this.addFaqData.splice(i, 1);
        },
        addEventsItem(i) {
            const obj = {
                name: '',
                link: ''
            };
            this.addEventsData.splice(i, 0, obj);
        },
        delEventsItem(i) {
            this.addEventsData.splice(i, 1);
        }
    }
})
</script>
<style lang="less" scoped>
    .el-form{
        max-width: 800px;
        .faq_title{
            font-size: 18px;
            font-weight: 600;
            margin-bottom: 20px;
            .flexLayout(flex-start);
            .add_faq{
                color: @colorBlue;
                font-size: 22px;
                margin-left: 10px;
            }
        }
        .add_item{
            position: relative;
            .el-form-item{
                margin-bottom: 10px;
            }
            .textarea_item{
                padding-bottom: 10px;
                border-bottom: 1px dashed #999;
            }
            .act_box{
                position: absolute;
                right: -70px;
                top: 3px;
                width: 60px;
                font-size: 20px;
                color: @colorDel;
                cursor: pointer;
                .add_faq{
                    color: @colorBlue;
                    font-size: 22px;
                    margin-right: 10px;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/view/app/product-service-center/faq-update.vue